import React, { use, useEffect } from "react";
import { CityForm } from "./Forms/CityForm";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Container, Form, Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  useGetOneCityQuery,
  useUpdateCityMutation,
} from "../../services/basicData/basicData";
import { useParams } from "react-router";
import { FormSkeleton } from "./FormFieldSkeletons";

export const EditCity = () => {
  const { t } = useTranslation();

  const { id } = useParams();
  const {
    data: cityResponse,
    isLoading,
    isFetching,
  } = useGetOneCityQuery({ id });
  const city = cityResponse?.data?.data;
  const loading = isLoading || isFetching;
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { mutate: updateCity, isPending } = useUpdateCityMutation(setError);

  const onSubmit = (data) => {
    updateCity(data);
  };

  useEffect(() => {
    if (city) {
      reset(city);
    }
  }, [city]);

  return (
    <Stack gap={2}>
      <PageHeader
        title={t("EDIT_CITY")}

      />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <FormSkeleton />
          ) : (
            <>
              <CityForm control={control} errors={errors} />
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("UPDATING_CITY")}
                  </>
                ) : (
                  t("UPDATE_CITY")
                )}
              </Button>
            </>
          )}
        </Form>
      </Container>
    </Stack>
  );
};
